module.exports = __webpack_public_path__ + "static/media/26_B.963e7aa8.png";